import { render, staticRenderFns } from "./TopicsLayout.vue?vue&type=template&id=5bbab980&"
import script from "./TopicsLayout.vue?vue&type=script&lang=js&"
export * from "./TopicsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports